const PanelDataSource = {
  install: function (Vue, options) {
    const rest = {
      get: (url, params) => {
        return axios.get(url, params).then((r) => r.data);
      },
      post: (url, data, params) => {
        return axios.post(url, data, params).then((r) => r.data);
      },
      patch: (url, data, params) => {
        return axios.patch(url, data, params).then((r) => r.data);
      },
      delete: (url, data, params) => {
        return axios.delete(url, data, params).then((r) => r.data);
      },
    };

    /*
        User
     */

    const getUserData = () => {
      return rest.get('/usuarios/datos/');
    };

    const reactivateUser = () => {
      return rest.post('/usuarios/reactivar/');
    };

    const whitelistUser = () => {
      return rest.post('/usuarios/whitelist/');
    };

    const getNotifications = (page = 1) => {
      return rest.get('/notificaciones/', { params: { page } });
    };
    const markNotification = (nid, status) => {
      return rest.post('/notificaciones/marcar/', { id: nid, status });
    };
    const markAllNotifications = () => {
      return rest.post('/notificaciones/marcar/todas/');
    };

    /*
        Profile
     */
    const getProfileData = () => {
      return rest.get('/directorio/datos/');
    };
    const saveProfileData = (profile) => {
      return rest.post('/directorio/datos/', { profile });
    };

    /*
        Servicios
    */

    const getServicesData = () => {
      return rest.get('/servicios/datos/');
    };
    const getServiceData = (sid) => {
      return rest.get(`/servicios/datos/${sid}/`);
    };
    const saveServiceData = (service) => {
      return rest.post('/servicios/datos/', { service });
    };
    const deleteServicesData = (sid) => {
      return rest.delete(`/servicios/datos/${sid}/`);
    };
    const deactivateServicesData = (service) => {
      return rest.post('/servicios/estado/', { service, status: 'inactive' });
    };
    const reactivateServicesData = (service) => {
      return rest.post('/servicios/estado/', { service, status: 'active' });
    };
    const updateServiceFile = (data) => {
      return rest.patch('/servicios/archivos/', { ...data });
    };
    const removeServiceFile = (data) => {
      return rest.delete('/servicios/archivos/', { data });
    };

    /*
        Jobs
     */
    const getJobsData = (page = 1) => {
      return rest.get('/empleo/datos/', { params: { page } });
    };
    const getJobData = (jid) => {
      return rest.get('/empleo/datos/' + jid + '/');
    };
    const getJobProfiles = (jid) => {
      return rest.get('/empleo/perfiles/' + jid + '/');
    };
    const saveJobsData = (job) => {
      return rest.post('/empleo/datos/', { job });
    };
    const createJobsData = (job) => {
      return rest.post('/empleo/publicar/', { job });
    };
    const deactivateJobsData = (job) => {
      return rest.post('/empleo/estado/', { job, status: 'inactive' });
    };
    const reactivateJobsData = (job) => {
      return rest.post('/empleo/estado/', { job, status: 'active' });
    };
    const renewJobsData = (job) => {
      return rest.post('/empleo/renovar/', { job });
    };
    const closeJobsData = (job) => {
      return rest.post('/empleo/estado/', { job, status: 'closed' });
    };
    const deleteJobsData = (job) => {
      return rest.post('/empleo/estado/', { job, status: 'delete' });
    };

    const getJobsSuggestions = () => {
      return rest.get('/empleo/recomendados/');
    };

    /*
		Applications
	 */

    const getApplications = () => {
      return rest.get('/empleo/inscripciones/');
    };

    const removeApplication = (application) => {
      return rest.delete('/empleo/inscripcion/', { params: { application } });
    };

    Vue.prototype.$dmtk = {
      jobs: {
        get: getJobsData,
        recommended: getJobProfiles,
        read: getJobData,
        save: saveJobsData,
        publish: createJobsData,
        deactivate: deactivateJobsData,
        reactivate: reactivateJobsData,
        close: closeJobsData,
        renew: renewJobsData,
        delete: deleteJobsData,
        suggestions: getJobsSuggestions,
      },
      profile: {
        get: getProfileData,
        save: saveProfileData,
      },
      services: {
        get: getServicesData,
        read: getServiceData,
        save: saveServiceData,
        delete: deleteServicesData,
        deactivate: deactivateServicesData,
        reactivate: reactivateServicesData,
        updateFile: updateServiceFile,
        removeFile: removeServiceFile,
      },
      user: {
        get: getUserData,
        //save: getUserData,
        resend: reactivateUser,
        whitelist: whitelistUser,
      },
      notifications: {
        get: getNotifications,
        mark: markNotification,
        markAll: markAllNotifications,
      },
      applications: {
        get: getApplications,
        close: removeApplication,
      },
    };
  },
};
